import React from "react";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-navy text-white/70 py-12" data-testid="footer">
      <div className="container-tight grid md:grid-cols-3 gap-8 items-start">
        <div>
          <p className="font-heading text-3xl text-white">Zorba</p>
          <p className="mt-2 text-sm text-white/60">Velero clásico · 18 m · Hasta 12 pax + tripulación</p>
          <p className="mt-1 text-sm text-white/60">Portonovo · Rías Baixas · Galicia</p>
          <a
            href="https://www.instagram.com/zorba_sailingboat"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="mt-5 inline-flex items-center gap-2 text-white/85 hover:text-sand transition-colors text-sm"
          >
            <Instagram size={18} strokeWidth={1.6} />
            @zorba_sailingboat
          </a>
        </div>
        <div className="text-sm space-y-1">
          <p className="text-white/90">Contacto directo</p>
          <a href="https://wa.me/34649927028" target="_blank" rel="noopener noreferrer" className="block hover:text-sand transition-colors">
            WhatsApp · +34 649 927 028
          </a>
          <a href="mailto:info@zorba.gal" className="block hover:text-sand transition-colors">
            info@zorba.gal
          </a>
          <a
            href="https://www.instagram.com/zorba_sailingboat"
            target="_blank"
            rel="noopener noreferrer"
            className="block hover:text-sand transition-colors"
          >
            Instagram · @zorba_sailingboat
          </a>
        </div>
        <div className="text-sm md:text-right">
          <p>© {new Date().getFullYear()} Velero Zorba</p>
          <p className="text-white/50 mt-1 italic">Una embarcación viva, cuidada y con historia.</p>
        </div>
      </div>
    </footer>
  );
}
